import "./EditarUsuario.css"
import TextInput from "../../../components/TextInput/TextInput"
import { useState, useEffect } from "react"
import { getDatabase, ref, onValue, remove, update } from 'firebase/database';
import AlertMsg from "../../../components/AlertMsg/AlertMsg.jsx";
import Common from "../../../components/js/Common";
import appFirebase from "../../../firebase-config.js";
import ToggleButton from "../../../components/ToggleButton/ToggleButton.jsx";
import { getAuth, signInWithEmailAndPassword, updatePassword, updateEmail, reauthenticateWithCredential, EmailAuthProvider, createUserWithEmailAndPassword, fetchSignInMethodsForEmail } from "firebase/auth";
import { useParams, useHistory } from "react-router-dom";
import CountryCodeModal from "../../../components/CountryCodeModal/CountryCodeModal.jsx";
import KycDocuments from "../../../components/KycDocuments/KycDocuments.jsx";
import KycDocumentModel from "../../../model/KycDocumentModel.js";
const auth = getAuth(appFirebase)


const EditarUsuario = () => {
    const { fk } = useParams();
    const history = useHistory();
    const [userDetails, setUserDetails] = useState({
        userName: "",
        password: "",
        email: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        country: "",
        countryCode: "",
        usdtAddress: "",
        admissionDate: "",
        rank: 0,
        referredBy: "",
        walletCom: 0,
        walletDiv: 0,
        walletTotal: 0,
        retiros: 0,
        bonoFastTrack: 0,
        bonoIgualacion: 0,
        bonoIngresoRes: 0,
        bonoRangoRes: 0,
        bonoRefDirect: 0,
        staterPack: 0,
        creditoCorpo: 0,
        permisos: { promo: false, retiroDiv: true, retiroCom: true, matchingBono: true, permitirPagarDiv: true, pagarConCredito: false },
        deuda: 0,
        activo: false,
        validity: "",
        rol: "u",
        nip: "",
        capitalIntComp: 0,
        intComp: "00",
        finIntComp: "",

    });
    const [agregarDeuda, setAgregarDeuda] = useState(0);
    const [deudaActual, setDeudaActual] = useState(0);
    const [visible, setVisible] = useState(false);
    const [msj, setMsj] = useState("");
    const [visibleAlert, setVisibleAlert] = useState(false);
    const [visibleDetailsDeuda, setVisibleDetailsDeuda] = useState(true);
    const [showCountryCodeModal, setShowCountryCodeModal] = useState(false);
    const [activeTab, setActiveTab] = useState('personal');
    const [emailChangeModal, setEmailChangeModal] = useState(false);
    const [newEmail, setNewEmail] = useState("");
    const [emailChangeLoading, setEmailChangeLoading] = useState(false);
    const [emailErrors, setEmailErrors] = useState({});
    const [kycDocuments, setKycDocuments] = useState({});
    const [reviewModal, setReviewModal] = useState({ show: false, documentType: null, currentStatus: null });

    useEffect(() => {
        const db = getDatabase();
        const userRef = ref(db, 'users/' + fk);

        const unsubscribe = onValue(userRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                setDeudaActual(data.deuda)
                setUserDetails(prevState => ({ ...prevState, ...data }));
                console.log(data)
            } else {
                console.log("No such document!");
            }
        });

        return () => unsubscribe();
    }, [fk]);

    useEffect(() => {
        if (!fk) return;
        const unsubscribe = KycDocumentModel.getUserDocuments(fk, (data) => {
            setKycDocuments(data);
        });
        return () => unsubscribe();
    }, [fk]);

    const handleChange = (key, value, isNumber) => {
        if (isNumber)
            value = Number(value)

        setUserDetails(prevDetails => ({ ...prevDetails, [key]: value }));
    };

    const editarUser = async () => {
        const common = new Common();
        const newDeuda = userDetails.deuda + Number(agregarDeuda)
        const newCredito = userDetails.creditoCorpo + Number(agregarDeuda)
        let updatedUser = {
            ...userDetails,
            //password: await cambiarContraseña(userDetails.password),
            deuda: newDeuda,
            creditoCorpo: newCredito
        };
        common.editAnyUser(updatedUser);
        setAgregarDeuda(0)
    };

    const cambiarContraseña = async (newPass) => {
        if (userDetails.password !== newPass) {
            const userCredential = await signInWithEmailAndPassword(auth, userDetails.email, userDetails.password);
            const userCurrent = userCredential.user;
            await updatePassword(userCurrent, newPass);
            return newPass;
        } else {
            return userDetails.password;
        }
    };

    const save = () => {
        try {
            editarUser();
            setVisible(true);
            setMsj("Cambios realizados exitosamente");
        } catch (error) {
            setMsj("Error guardando datos");
        }
    };

    const eliminarUsuario = () => {
        const db = getDatabase();
        const userRef = ref(db, 'users/' + fk);

        remove(userRef)
            .then(() => {
                setVisible(true);
                setMsj("Usuario eliminado exitosamente");
                history.push('/admin/gestionar-ususarios');
            })
            .catch((error) => {
                console.error('Error al eliminar el usuario: ', error);
            });
    };

    const regresar = () => {
        history.push('/admin/gestionar-ususarios');
    };

    const openCloseDetailsDeuda = () => {
        setVisibleDetailsDeuda(!visibleDetailsDeuda)
    }

    const openCountryCodeModal = () => {
        setShowCountryCodeModal(true);
    }

    const closeCountryCodeModal = () => {
        setShowCountryCodeModal(false);
        // Recargar los datos del usuario
        const db = getDatabase();
        const userRef = ref(db, 'users/' + fk);
        onValue(userRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                setUserDetails(prevState => ({ ...prevState, ...data }));
            }
        }, { onlyOnce: true });
    }

    // Función para validar formato de email
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    // Función mejorada para cambiar email y crear nuevo usuario en Auth
    const changeUserEmail = async () => {
        setEmailChangeLoading(true);
        setEmailErrors({});

        try {
            // Validaciones previas
            if (!newEmail || !validateEmail(newEmail)) {
                setEmailErrors({ email: "Por favor ingresa una dirección de email válida" });
                return;
            }

            if (newEmail === userDetails.email) {
                setEmailErrors({ email: "El nuevo email es igual al actual" });
                return;
            }

            const db = getDatabase();

            // Verificación 1: Comprobar si el email existe en la base de datos
            const usersRef = ref(db, 'users');
            const emailExistsInDB = await new Promise((resolve) => {
                onValue(usersRef, (snapshot) => {
                    const users = snapshot.val();
                    if (!users || typeof users !== 'object') {
                        resolve(false);
                        return;
                    }

                    const emailExists = Object.values(users).some(user =>
                        user && user.email === newEmail && user.email !== userDetails.email
                    );
                    resolve(emailExists);
                }, { onlyOnce: true });
            });

            if (emailExistsInDB) {
                setEmailErrors({ email: "Este email ya está en uso por otro usuario en la base de datos" });
                return;
            }

            // Verificación 2: Comprobar si el email existe en Firebase Auth
            let emailExistsInAuth = false;
            try {
                const signInMethods = await fetchSignInMethodsForEmail(auth, newEmail);
                emailExistsInAuth = signInMethods.length > 0;
            } catch (authCheckError) {
                console.log("No se pudo verificar el email en Auth:", authCheckError.message);
                // Si no se puede verificar, continuamos (puede ser un problema de red)
            }

            if (emailExistsInAuth) {
                setEmailErrors({ email: "Este email ya está registrado en Firebase Authentication" });
                return;
            }

            // Crear nuevo usuario en Firebase Auth con el nuevo email
            try {
                // Crear nuevo usuario en Auth con la misma contraseña
                const newUserCredential = await createUserWithEmailAndPassword(auth, newEmail, userDetails.password);
                const newUser = newUserCredential.user;

                console.log("Nuevo usuario creado en Firebase Auth:", newUser.uid);

                // Actualizar en la base de datos
                const userRef = ref(db, 'users/' + fk);
                await update(userRef, {
                    email: newEmail,
                    emailUpdateDate: new Date().toISOString(),
                    emailUpdatedBy: auth.currentUser?.email || 'admin',
                    firebaseAuthUID: newUser.uid, // Guardar el nuevo UID
                    previousEmail: userDetails.email,
                    emailAuthUpdated: true,
                    emailVerificationStatus: {
                        dbUpdated: true,
                        authCreated: true,
                        createdAt: new Date().toISOString()
                    }
                });

                // Actualizar el estado local
                setUserDetails(prev => ({ ...prev, email: newEmail }));

                // Cerrar modal y mostrar éxito
                setEmailChangeModal(false);
                setNewEmail("");
                setVisible(true);
                setMsj("✅ ¡Email actualizado exitosamente! Nueva cuenta de Firebase Auth creada. El usuario ahora puede iniciar sesión con el nuevo email y la misma contraseña.");

            } catch (authError) {
                console.error("Error creando nuevo usuario en Firebase Auth:", authError);

                if (authError.code === 'auth/email-already-in-use') {
                    setEmailErrors({ email: "Este email ya está registrado en Firebase Auth (la verificación pudo haber fallado)" });
                } else if (authError.code === 'auth/weak-password') {
                    setEmailErrors({ general: "La contraseña es muy débil para crear una nueva cuenta. Por favor actualiza la contraseña del usuario primero." });
                } else if (authError.code === 'auth/invalid-password') {
                    setEmailErrors({ general: "Formato de contraseña inválido. No se puede crear nueva cuenta con la contraseña actual." });
                } else {
                    // Si falla crear en Auth, al menos actualizar en base de datos
                    const userRef = ref(db, 'users/' + fk);
                    await update(userRef, {
                        email: newEmail,
                        emailUpdateDate: new Date().toISOString(),
                        emailUpdatedBy: auth.currentUser?.email || 'admin',
                        previousEmail: userDetails.email,
                        emailAuthUpdatePending: true, // Marcar como pendiente
                        authCreationError: authError.message,
                        emailVerificationStatus: {
                            dbUpdated: true,
                            authCreated: false,
                            error: authError.message,
                            attemptedAt: new Date().toISOString()
                        }
                    });

                    setUserDetails(prev => ({ ...prev, email: newEmail }));
                    setEmailChangeModal(false);
                    setNewEmail("");
                    setVisible(true);
                    setMsj("⚠️ Email actualizado en la base de datos, pero falló la creación de cuenta en Firebase Auth. Error: " + authError.message + ". El usuario puede necesitar asistencia manual.");
                }
            }

        } catch (error) {
            console.error("Error cambiando email:", error);
            setEmailErrors({ general: "Error actualizando email: " + error.message });
        } finally {
            setEmailChangeLoading(false);
        }
    };

    // Función para abrir modal de cambio de email
    const openEmailChangeModal = () => {
        setNewEmail(userDetails.email);
        setEmailChangeModal(true);
        setEmailErrors({});
    };

    // Funciones para manejar KYC
    const openReviewModal = (documentType, currentStatus) => {
        setReviewModal({ show: true, documentType, currentStatus });
    };

    const closeReviewModal = () => {
        setReviewModal({ show: false, documentType: null, currentStatus: null });
    };

    const handleReviewDocument = async (status, notes) => {
        try {
            await KycDocumentModel.updateDocumentStatus(fk, reviewModal.documentType, status, notes);
            setVisible(true);
            setMsj(`Document ${status} successfully`);
            closeReviewModal();
        } catch (error) {
            console.error('Error updating document status:', error);
            setVisible(true);
            setMsj('Error updating document status');
        }
    };

    return (
        <section className="edit-user-container">
            <AlertMsg visible={visible} setVisible={setVisible} texto={msj} />

            {/* Modal de cambio de email */}
            {emailChangeModal && (
                <section className="email-change-modal-overlay">
                    <div className="email-change-modal">
                        <div className="email-modal-header">
                            <h3>Cambiar Email del Usuario</h3>
                            <button
                                onClick={() => setEmailChangeModal(false)}
                                className="modal-close-btn"
                            >
                                <i className="bi bi-x-lg"></i>
                            </button>
                        </div>
                        <div className="email-modal-body">
                            <div className="current-email-display">
                                <label>Email Actual:</label>
                                <span>{userDetails.email}</span>
                            </div>

                            <div className="form-field">
                                <label>Nueva Dirección de Email:</label>
                                <input
                                    type="email"
                                    value={newEmail}
                                    onChange={(e) => setNewEmail(e.target.value)}
                                    placeholder="Ingresa la nueva dirección de email"
                                    className={emailErrors.email ? 'error' : ''}
                                />
                                {emailErrors.email && (
                                    <span className="error-message">{emailErrors.email}</span>
                                )}
                            </div>

                            {emailErrors.general && (
                                <div className="general-error">
                                    <i className="bi bi-exclamation-triangle"></i>
                                    {emailErrors.general}
                                </div>
                            )}
                        </div>
                        <div className="email-modal-actions">
                            <button
                                onClick={() => setEmailChangeModal(false)}
                                className="btn-cancel"
                                disabled={emailChangeLoading}
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={changeUserEmail}
                                className="btn-primary"
                                disabled={emailChangeLoading || !newEmail}
                            >
                                {emailChangeLoading ? (
                                    <>
                                        <span className="spinner-small"></span>
                                        Actualizando...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-check-circle"></i>
                                        Actualizar Email
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </section>
            )}

            {/* Modal de código de país */}
            <CountryCodeModal
                isOpen={showCountryCodeModal}
                onClose={closeCountryCodeModal}
            />

            {/* Modal de confirmación de eliminación */}
            {visibleAlert && (
                <section className="delete-modal-overlay">
                    <div className="delete-modal">
                        <div className="delete-modal-header">
                            <h3>Confirmar eliminación</h3>
                        </div>
                        <div className="delete-modal-body">
                            <p>¿Estás seguro de que deseas eliminar al usuario <strong>{userDetails.userName}</strong>?</p>
                            <p className="delete-warning">Esta acción no se puede deshacer.</p>
                        </div>
                        <div className="delete-modal-actions">
                            <button onClick={() => setVisibleAlert(false)} className="btn-cancel">
                                Cancelar
                            </button>
                            <button onClick={eliminarUsuario} className="btn-delete">
                                Eliminar
                            </button>
                        </div>
                    </div>
                </section>
            )}

            {/* Header con información del usuario */}
            <div className="user-header">
                <div className="user-info">
                    <div className="user-avatar">
                        <i className="bi bi-person-circle"></i>
                    </div>
                    <div className="user-details">
                        <h1>{userDetails.userName || 'Usuario'}</h1>
                        <p>{userDetails.email}</p>
                        <div className="user-status">
                            <span className={`status-badge ${userDetails.activo ? 'active' : 'inactive'}`}>
                                {userDetails.activo ? 'Activo' : 'Inactivo'}
                            </span>
                            <span className="rank-badge">Rango {userDetails.rank || 0}</span>
                        </div>
                    </div>
                </div>
                <div className="header-actions">
                    <button onClick={regresar} className="btn-secondary">
                        <i className="bi bi-arrow-left"></i>
                        Regresar
                    </button>
                    <button onClick={save} className="btn-primary">
                        <i className="bi bi-check-circle"></i>
                        Guardar
                    </button>
                    <button onClick={() => setVisibleAlert(true)} className="btn-danger">
                        <i className="bi bi-trash"></i>
                        Eliminar
                    </button>
                </div>
            </div>

            {/* Navegación por pestañas */}
            <div className="tabs-container">
                <div className="tabs-nav">
                    <button
                        className={`tab-button ${activeTab === 'personal' ? 'active' : ''}`}
                        onClick={() => setActiveTab('personal')}
                    >
                        <i className="bi bi-person"></i>
                        Datos Personales
                    </button>
                    <button
                        className={`tab-button ${activeTab === 'financial' ? 'active' : ''}`}
                        onClick={() => setActiveTab('financial')}
                    >
                        <i className="bi bi-wallet2"></i>
                        Datos Financieros
                    </button>
                    <button
                        className={`tab-button ${activeTab === 'permissions' ? 'active' : ''}`}
                        onClick={() => setActiveTab('permissions')}
                    >
                        <i className="bi bi-shield-check"></i>
                        Permisos
                    </button>
                    <button
                        className={`tab-button ${activeTab === 'corporate' ? 'active' : ''}`}
                        onClick={() => setActiveTab('corporate')}
                    >
                        <i className="bi bi-building"></i>
                        Préstamo Corporativo
                    </button>
                    <button
                        className={`tab-button ${activeTab === 'compound-interest' ? 'active' : ''}`}
                        onClick={() => setActiveTab('compound-interest')}
                    >
                        <i className="bi bi-graph-up-arrow"></i>
                        Interés Compuesto
                    </button>
                    <button
                        className={`tab-button ${activeTab === 'kyc' ? 'active' : ''}`}
                        onClick={() => setActiveTab('kyc')}
                    >
                        <i className="bi bi-shield-check"></i>
                        KYC Verification
                    </button>
                </div>

                {/* Contenido de las pestañas */}
                <div className="tab-content">
                    {/* Pestaña de Datos Personales */}
                    {activeTab === 'personal' && (
                        <div className="tab-panel">
                            <div className="panel-header">
                                <h2>Información Personal</h2>
                                <p>Gestiona los datos básicos del usuario</p>
                            </div>

                            <div className="form-grid">
                                {/* Información básica */}
                                <div className="form-section">
                                    <h3>Información Básica</h3>
                                    <div className="form-row">
                                        <TextInput
                                            ti="Nombre de usuario"
                                            value={userDetails.userName}
                                            setValue={(value) => handleChange("userName", value, false)}
                                        />
                                        {/* Campo de email mejorado */}
                                        <div className="email-field-container">
                                            <label>Email</label>
                                            <div className="email-display">
                                                <span className="email-value">{userDetails.email}</span>
                                                <button
                                                    type="button"
                                                    onClick={openEmailChangeModal}
                                                    className="btn-change-email"
                                                    title="Cambiar dirección de email"
                                                >
                                                    <i className="bi bi-pencil"></i>
                                                    Cambiar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <TextInput
                                            ti="Nombre"
                                            value={userDetails.firstName}
                                            setValue={(value) => handleChange("firstName", value, false)}
                                        />
                                        <TextInput
                                            ti="Apellidos"
                                            value={userDetails.lastName}
                                            setValue={(value) => handleChange("lastName", value, false)}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <TextInput
                                            ti="Teléfono"
                                            value={userDetails.phoneNumber}
                                            setValue={(value) => handleChange("phoneNumber", value, false)}
                                        />
                                        <TextInput
                                            ti="Contraseña"
                                            value={userDetails.password}
                                            setValue={(value) => handleChange("password", value, false)}
                                        />
                                    </div>
                                </div>

                                {/* Información de país */}
                                <div className="form-section">
                                    <h3>Información del País</h3>
                                    <div className="country-info-section">
                                        <div className="country-display-admin">
                                            <div className="country-field">
                                                <label>País actual:</label>
                                                <span>{userDetails.country || 'No asignado'}</span>
                                            </div>
                                            <div className="country-field">
                                                <label>Código de país:</label>
                                                <span>{userDetails.countryCode || 'No asignado'}</span>
                                            </div>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={openCountryCodeModal}
                                            className="btn-country"
                                        >
                                            <i className="bi bi-globe"></i>
                                            {userDetails.countryCode ? 'Cambiar País' : 'Asignar País'}
                                        </button>
                                    </div>
                                </div>

                                {/* Información adicional */}
                                <div className="form-section">
                                    <h3>Información Adicional</h3>
                                    <div className="form-row">
                                        <TextInput
                                            ti="Dirección USDT (TRC20)"
                                            value={userDetails.usdtAddress}
                                            setValue={(value) => handleChange("usdtAddress", value, false)}
                                        />
                                        <TextInput
                                            ti="Fecha de admisión"
                                            value={userDetails.admissionDate}
                                            setValue={(value) => handleChange("admissionDate", value, false)}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <TextInput
                                            ti="Referido por"
                                            value={userDetails.referredBy}
                                            setValue={(value) => handleChange("referredBy", value, false)}
                                        />
                                        <TextInput
                                            ti="NIP"
                                            value={userDetails.nip}
                                            setValue={(value) => handleChange("nip", value, false)}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <TextInput
                                            ti="Rango"
                                            value={userDetails.rank}
                                            setValue={(value) => handleChange("rank", value, true)}
                                        />
                                        <div className="select-field">
                                            <label>Rol:</label>
                                            <select
                                                value={userDetails.rol}
                                                onChange={(e) => handleChange("rol", e.target.value, false)}
                                            >
                                                <option value="u">Usuario</option>
                                                <option value="admin">Administrador</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Pestaña de Datos Financieros */}
                    {activeTab === 'financial' && (
                        <div className="tab-panel">
                            <div className="panel-header">
                                <h2>Información Financiera</h2>
                                <p>Gestiona los datos financieros y wallets del usuario</p>
                            </div>

                            <div className="form-grid">
                                {/* Wallets principales */}
                                <div className="form-section">
                                    <h3>Wallets Principales</h3>
                                    <div className="form-row">
                                        <TextInput
                                            ti="Wallet de Comisiones"
                                            value={userDetails.walletCom}
                                            setValue={(value) => handleChange("walletCom", value, true)}
                                        />
                                        <TextInput
                                            ti="Wallet de Dividendos"
                                            value={userDetails.walletDiv}
                                            setValue={(value) => handleChange("walletDiv", value, true)}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <TextInput
                                            ti="Ganancias Totales"
                                            value={userDetails.walletTotal}
                                            setValue={(value) => handleChange("walletTotal", value, true)}
                                        />
                                        <TextInput
                                            ti="Retiros Totales"
                                            value={userDetails.retiros}
                                            setValue={(value) => handleChange("retiros", value, true)}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <TextInput
                                            ti="Starter Pack"
                                            value={userDetails.staterPack}
                                            setValue={(value) => handleChange("staterPack", value, true)}
                                        />
                                    </div>
                                </div>

                                {/* Bonos */}
                                <div className="form-section">
                                    <h3>Bonos</h3>
                                    <div className="form-row">
                                        <TextInput
                                            ti="Bono Fast Track"
                                            value={userDetails.bonoFastTrack}
                                            setValue={(value) => handleChange("bonoFastTrack", value, true)}
                                        />
                                        <TextInput
                                            ti="Bono de Igualación"
                                            value={userDetails.bonoIgualacion}
                                            setValue={(value) => handleChange("bonoIgualacion", value, true)}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <TextInput
                                            ti="Bono Ingreso Residual"
                                            value={userDetails.bonoIngresoRes}
                                            setValue={(value) => handleChange("bonoIngresoRes", value, true)}
                                        />
                                        <TextInput
                                            ti="Bono Rango Residual"
                                            value={userDetails.bonoRangoRes}
                                            setValue={(value) => handleChange("bonoRangoRes", value, true)}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <TextInput
                                            ti="Bono Referencia Directa"
                                            value={userDetails.bonoRefDirect}
                                            setValue={(value) => handleChange("bonoRefDirect", value, true)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Pestaña de Permisos */}
                    {activeTab === 'permissions' && (
                        <div className="tab-panel">
                            <div className="panel-header">
                                <h2>Permisos de Usuario</h2>
                                <p>Configura los permisos y accesos del usuario</p>
                            </div>

                            <div className="permissions-grid">
                                <div className="permission-item">
                                    <div className="permission-info">
                                        <h4>Retirar de Dividendos</h4>
                                        <p>Permite al usuario retirar fondos de su wallet de dividendos</p>
                                    </div>
                                    <ToggleButton
                                        permiso={userDetails.permisos.retiroDiv}
                                        onToggle={(newValue) => handleChange("permisos", { ...userDetails.permisos, retiroDiv: newValue })}
                                    />
                                </div>

                                <div className="permission-item">
                                    <div className="permission-info">
                                        <h4>Retirar de Comisiones</h4>
                                        <p>Permite al usuario retirar fondos de su wallet de comisiones</p>
                                    </div>
                                    <ToggleButton
                                        permiso={userDetails.permisos.retiroCom}
                                        onToggle={(newValue) => handleChange("permisos", { ...userDetails.permisos, retiroCom: newValue })}
                                    />
                                </div>

                                <div className="permission-item">
                                    <div className="permission-info">
                                        <h4>Promoción 10%</h4>
                                        <p>Activa la promoción especial del 10% para el usuario</p>
                                    </div>
                                    <ToggleButton
                                        permiso={userDetails.permisos.promo}
                                        onToggle={(newValue) => handleChange("permisos", { ...userDetails.permisos, promo: newValue })}
                                    />
                                </div>

                                <div className="permission-item">
                                    <div className="permission-info">
                                        <h4>Matching Bono</h4>
                                        <p>Permite al usuario recibir bonos de igualación</p>
                                    </div>
                                    <ToggleButton
                                        permiso={userDetails.permisos.matchingBono}
                                        onToggle={(newValue) => handleChange("permisos", { ...userDetails.permisos, matchingBono: newValue })}
                                    />
                                </div>

                                <div className="permission-item">
                                    <div className="permission-info">
                                        <h4>Pagar Facturas con Dividendos</h4>
                                        <p>Permite usar dividendos para pagar facturas</p>
                                    </div>
                                    <ToggleButton
                                        permiso={userDetails.permisos.permitirPagarDiv}
                                        onToggle={(newValue) => handleChange("permisos", { ...userDetails.permisos, permitirPagarDiv: newValue })}
                                    />
                                </div>

                                <div className="permission-item">
                                    <div className="permission-info">
                                        <h4>Usuario Activo</h4>
                                        <p>Define si el usuario está activo en el sistema</p>
                                    </div>
                                    <ToggleButton
                                        permiso={userDetails.activo}
                                        onToggle={(newValue) => handleChange("activo", newValue)}
                                    />
                                </div>

                                <div className="permission-item">
                                    <div className="permission-info">
                                        <h4>Pagar Facturas con 100% Crédito</h4>
                                        <p>Permite al usuario pagar facturas utilizando el 100% del crédito disponible</p>
                                    </div>
                                    <ToggleButton
                                        permiso={userDetails.permisos.pagarConCredito}
                                        onToggle={(newValue) => handleChange("permisos", { ...userDetails.permisos, pagarConCredito: newValue })}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Pestaña de Préstamo Corporativo */}
                    {activeTab === 'corporate' && (
                        <div className="tab-panel">
                            <div className="panel-header">
                                <h2>Préstamo Corporativo</h2>
                                <p>Gestiona el crédito corporativo y la deuda del usuario</p>
                            </div>

                            <div className="corporate-section">
                                <div className="debt-summary">
                                    <div className="debt-card">
                                        <h3>Resumen de Deuda</h3>
                                        <div className="debt-amount">
                                            <span className="amount">{deudaActual || 0}</span>
                                            <span className="currency">USDT</span>
                                        </div>
                                    </div>
                                    <div className="credit-card">
                                        <h3>Crédito Corporativo</h3>
                                        <div className="credit-amount">
                                            <span className="amount">{userDetails.creditoCorpo || 0}</span>
                                            <span className="currency">USDT</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="debt-management">
                                    <h3>Gestión de Capital</h3>
                                    <div className="add-debt-section">
                                        <TextInput
                                            ti="Agregar capital (puede ser negativo para reducir)"
                                            value={agregarDeuda}
                                            setValue={setAgregarDeuda}
                                        />
                                        <p className="help-text">
                                            Ingresa un número positivo para agregar capital/deuda o negativo para reducir.
                                        </p>
                                    </div>

                                    <div className="current-debt-display">
                                        <TextInput
                                            ti="Deuda Actual"
                                            value={userDetails.deuda}
                                            setValue={(value) => handleChange("deuda", value, true)}
                                        />
                                        <TextInput
                                            ti="Crédito Corporativo"
                                            value={userDetails.creditoCorpo}
                                            setValue={(value) => handleChange("creditoCorpo", value, true)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Pestaña de Interés Compuesto */}
                    {activeTab === 'compound-interest' && (
                        <div className="tab-panel">
                            <div className="panel-header">
                                <h2>Interés Compuesto</h2>
                                <p>Configura el interés compuesto del usuario</p>
                            </div>

                            <div className="form-grid">
                                {/* Capital Acumulado */}
                                <div className="form-section">
                                    <h3>Capital e Intereses</h3>
                                    <div className="form-row">
                                        <TextInput
                                            ti="Capital Acumulado (Interés Compuesto)"
                                            value={userDetails.capitalIntComp}
                                            setValue={(value) => handleChange("capitalIntComp", value, true)}
                                        />
                                        <div className="date-field">
                                            <label>Fecha de Finalización</label>
                                            <input
                                                type="date"
                                                value={userDetails.finIntComp}
                                                onChange={(e) => handleChange("finIntComp", e.target.value, false)}
                                                className="date-input"
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Operadores Lógicos */}
                                <div className="form-section">
                                    <h3>Administrar Interés Compuesto</h3>
                                    <p className="section-description">Configura el interés compuesto</p>

                                    <div className="operators-grid">
                                        <div className="permission-item">
                                            <div className="permission-info">
                                                <h4>Wallet dividendo</h4>
                                                <p>Activar/Desactivar</p>
                                            </div>
                                            <ToggleButton
                                                permiso={userDetails.intComp && userDetails.intComp.charAt(0) === '1'}
                                                onToggle={(newValue) => {
                                                    const secondDigit = userDetails.intComp && userDetails.intComp.length > 1 ? userDetails.intComp.charAt(1) : '0';
                                                    handleChange("intComp", (newValue ? '1' : '0') + secondDigit, false);
                                                }}
                                            />
                                        </div>

                                        <div className="permission-item">
                                            <div className="permission-info">
                                                <h4>Wallet comission</h4>
                                                <p>Activar/Desactivar</p>
                                            </div>
                                            <ToggleButton
                                                permiso={userDetails.intComp && userDetails.intComp.length > 1 && userDetails.intComp.charAt(1) === '1'}
                                                onToggle={(newValue) => {
                                                    const firstDigit = userDetails.intComp && userDetails.intComp.charAt(0) || '0';
                                                    handleChange("intComp", firstDigit + (newValue ? '1' : '0'), false);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Pestaña de KYC */}
                    {activeTab === 'kyc' && (
                        <div className="tab-panel">
                            <div className="panel-header">
                                <h2>KYC Verification Documents</h2>
                                <p>Review and manage user's KYC documents</p>
                            </div>

                            <div className="kyc-admin-section">
                                <KycDocuments userId={fk} />

                                {/* Panel de revisión administrativa */}
                                <div className="kyc-admin-actions">
                                    <h3>Document Review</h3>
                                    <div className="kyc-documents-list">
                                        {Object.keys(kycDocuments).length > 0 ? (
                                            Object.entries(kycDocuments).map(([docType, doc]) => (
                                                <div key={docType} className="kyc-admin-card">
                                                    <div className="kyc-admin-info">
                                                        <h4>{docType.replace(/_/g, ' ').toUpperCase()}</h4>
                                                        <span className={`status-badge-admin status-${doc.status}`}>
                                                            {doc.status}
                                                        </span>
                                                        <p className="upload-date">
                                                            Uploaded: {new Date(doc.uploadDate).toLocaleDateString()}
                                                        </p>
                                                        {doc.reviewDate && (
                                                            <p className="review-date">
                                                                Reviewed: {new Date(doc.reviewDate).toLocaleDateString()}
                                                            </p>
                                                        )}
                                                        {doc.reviewNotes && (
                                                            <p className="review-notes-admin">
                                                                <strong>Notes:</strong> {doc.reviewNotes}
                                                            </p>
                                                        )}
                                                    </div>
                                                    <div className="kyc-admin-buttons">
                                                        <a
                                                            href={doc.downloadURL}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn-view-admin"
                                                        >
                                                            <i className="bi bi-eye"></i> View
                                                        </a>
                                                        {doc.status !== 'approved' && (
                                                            <button
                                                                onClick={() => openReviewModal(docType, 'approved')}
                                                                className="btn-approve"
                                                            >
                                                                <i className="bi bi-check-circle"></i> Approve
                                                            </button>
                                                        )}
                                                        {doc.status !== 'rejected' && (
                                                            <button
                                                                onClick={() => openReviewModal(docType, 'rejected')}
                                                                className="btn-reject"
                                                            >
                                                                <i className="bi bi-x-circle"></i> Reject
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="no-documents">
                                                <i className="bi bi-inbox"></i>
                                                <p>No KYC documents uploaded yet</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Modal de revisión de documentos KYC */}
            {reviewModal.show && (
                <KycReviewModal
                    documentType={reviewModal.documentType}
                    onClose={closeReviewModal}
                    onReview={handleReviewDocument}
                />
            )}
        </section>
    );
};

// Componente para el modal de revisión
const KycReviewModal = ({ documentType, onClose, onReview }) => {
    const [reviewNotes, setReviewNotes] = useState('');
    const [reviewAction, setReviewAction] = useState('');

    const handleSubmit = () => {
        if (!reviewAction) {
            alert('Please select an action (Approve or Reject)');
            return;
        }
        onReview(reviewAction, reviewNotes);
    };

    return (
        <div className="kyc-review-modal-overlay">
            <div className="kyc-review-modal">
                <div className="kyc-review-header">
                    <h3>Review Document: {documentType?.replace(/_/g, ' ').toUpperCase()}</h3>
                    <button onClick={onClose} className="modal-close-btn">
                        <i className="bi bi-x-lg"></i>
                    </button>
                </div>
                <div className="kyc-review-body">
                    <div className="review-actions-selection">
                        <label>Select Action:</label>
                        <div className="action-buttons">
                            <button
                                className={`action-btn approve ${reviewAction === 'approved' ? 'active' : ''}`}
                                onClick={() => setReviewAction('approved')}
                            >
                                <i className="bi bi-check-circle"></i> Approve
                            </button>
                            <button
                                className={`action-btn reject ${reviewAction === 'rejected' ? 'active' : ''}`}
                                onClick={() => setReviewAction('rejected')}
                            >
                                <i className="bi bi-x-circle"></i> Reject
                            </button>
                        </div>
                    </div>
                    <div className="review-notes-field">
                        <label>Review Notes:</label>
                        <textarea
                            value={reviewNotes}
                            onChange={(e) => setReviewNotes(e.target.value)}
                            placeholder="Add notes about this document (optional)"
                            rows="4"
                        />
                    </div>
                </div>
                <div className="kyc-review-actions">
                    <button onClick={onClose} className="btn-cancel-review">
                        Cancel
                    </button>
                    <button onClick={handleSubmit} className="btn-submit-review">
                        <i className="bi bi-check-lg"></i> Submit Review
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditarUsuario;
